

const ucNotificationMenus = [
  {
    icon: "phone_missed",
    key: "uc.missed-calls",
    color: "error",
    name: "Missed calls",
    description: "List",
    url: "home/app/uc/missed-calls",
    messageType: "4",
    count: "",
    productionReady: true,
  },
  {
    icon: "voicemail",
    key: "uc.voicemails",
    color: "secondary",
    name: "Voice mail",
    description: "List",
    url: "home/app/uce/voicemails",
    messageType: "1",
    count: "",
    productionReady: true,
  },
  // {
  //   icon: (
  //     <Tooltip title="Call Back">
  //       <Icon fontSize="small">phone_callback</Icon>
  //     </Tooltip>
  //   ),
  //   key: "uc.call-back",
  //   color: "warning",
  //   name: "Call Back",
  //   description: "Callbacks set for you by different users",
  //   url: "home/app/uc/callback",
  //   messageType: "5",
  //   count: "",
  // },
  {
    icon: "message",
    key: "uc.messages",
    color: "primary",
    name: "Messages",
    description: "Received",
    url: "home/app/uc/messages",
    messageType: "6",
    count: "",
    productionReady: true,
  },

  {
    icon: "fax",
    key: "uc.fax",
    color: "success",
    name: "Fax",
    description: "Received",
    url: "home/app/uc/Fax",
    messageType: "2",
    count: "",
    productionReady: true,
  },
  {
    icon: "list",
    color: "warning",
    key: "uc.history",
    name: "Call History",
    description: "List",
    url: "home/app/uc/cdr",
    productionReady: true,
  },

  {
    icon: "contacts",
    color: "error",
    key: "uc.contacts",
    name: "Contacts",
    description: "Phone Book",
    url: "home/app/uc/contacts",
    productionReady: true,
  },
  {
    icon: "contact_phone",
    color: "success",
    key: "uc.personal.phoneBook",
    name: "Personal Contacts",
    description: "List",
    url: "home/app/personalPhonBook",
    productionReady: true,
  },

  {
    icon: "account_box",
    color: "info",
    key: "uc.settings",
    name: "User Profile",
    description: "Configuration",
    url: "home/app/uc/settings",
    productionReady: true,
  },
  {
    icon: "message",
    color: "success",
    key: "uc.broadcasts.message",
    name: " Broadcasts Message",
    description: "Send to users",
    url: "home/app/broadcastsMessage",
    productionReady: true,
  },
  {
    icon: "fax",
    color: "warning",
    key: "uc.sendFax.details",
    name: "Sent-Fax-Status",
    description: "Progress",
    url: "home/app/Sent-Fax-Status",
    productionReady: true,
  },
  // {
  //   icon: "link",
  //   color: "secondary",
  //   key: "uc.conference.portal",
  //   name: "Conference Portal",
  //   description: "conference portal",
  //   url: "home/app/uc/ConferencePortal",
  // },
  {
    icon: "calendar_month_icon",
    color: "info",
    key: "uc.conference.calendar",
    name: "Conference Calendar",
    description: "",
    url: "home/app/uc/Conference",
    productionReady: true,
  },
  {
    icon: "music_video",
    key: "uc.conference.recording",
    name: "Conference Recording",
    description: "",
    url: "home/app/uc/ConferenceRecording",
    productionReady: true,
  },
  // {
  //   icon: "settings",
  //   color: "primary",
  //   key: "uc.conference.setting",
  //   name: "Conference Setting",
  //   description: "conference Setting",
  //   url: "home/app/uc/ConferenceSetting",
  // },
  // {
  //   icon: "groups",
  //   color: "info",
  //   key: "uc.Myconference",
  //   name: "My-Conference",
  //   description: "My-Conference",
  //   url: "home/app/uc/Myconference",
  // },
];

export { ucNotificationMenus };
